/**
 * The words under a count, in the number the count actually is.
 *
 * Home's first two lines used to disagree about the same number: the sentence
 * said "1 page — nothing needs attention" and the tile directly under it said
 * "1 pages". The sentence had the rule written inline, the way every other
 * sentence in this product does; the tiles had a fixed plural, the way a
 * metrics dashboard labels an axis. This product does not talk like a metrics
 * dashboard anywhere else, and a screen contradicting itself twice in four
 * lines is the first thing a customer reads.
 *
 * Both spellings rather than an `s` appended, because the plural is not always
 * on the last word: "images carried", "things to check", "redirects proposed".
 *
 * It takes the count so the call site reads as the sentence it produces —
 * `{n} {counted(n, 'page', 'pages')}` — rather than hiding a comparison
 * somewhere above.
 */
export function counted(n: number, one: string, many: string): string {
  return n === 1 ? one : many
}
